import { render } from "./ProductBulkUpsellUpdater.vue?vue&type=template&id=6a3d1019"
import script from "./ProductBulkUpsellUpdater.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBulkUpsellUpdater.vue?vue&type=script&setup=true&lang=js"

import "./ProductBulkUpsellUpdater.vue?vue&type=style&index=0&id=6a3d1019&lang=css"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Products/Table/ProductBulkUpsellUpdater.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a3d1019"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a3d1019', __exports__)) {
    api.reload('6a3d1019', __exports__)
  }
  
  module.hot.accept("./ProductBulkUpsellUpdater.vue?vue&type=template&id=6a3d1019", () => {
    api.rerender('6a3d1019', render)
  })

}


export default __exports__